// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tsw-group {
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 100%;
  margin-bottom: var(--cui-field-margin);
}

.tsw-textCol {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.tsw-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--cui-text-label);
}

.tsw-required {
  color: var(--cui-danger);
  margin-left: 3px;
}

.tsw-desc {
  font-size: 11.5px;
  color: var(--cui-text-muted);
  line-height: 1.4;
}

/* ---------- track (shared) ---------- */

.tsw-track {
  position: relative;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  border: none;
  border-radius: 999px;
  background: var(--cui-border);
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease, box-shadow 0.15s ease;
}

.tsw-track:focus-visible {
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

.tsw-track.tsw-on {
  background: linear-gradient(135deg, var(--cui-primary), var(--cui-primary-light));
}

.tsw-track.tsw-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.tsw-thumb {
  position: absolute;
  left: 2px;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transform: translateY(-50%);
  transition: left 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.tsw-track.tsw-on .tsw-thumb {
  left: calc(100% - 2px);
  transform: translate(-100%, -50%);
}

.tsw-thumbIcon {
  width: 60%;
  height: 60%;
  fill: none;
  stroke: var(--cui-primary);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.tsw-track.tsw-on .tsw-thumbIcon {
  stroke: var(--cui-primary);
}

.tsw-track:not(.tsw-on) .tsw-thumbIcon {
  stroke: #a8adb8;
}


.tsw-controlRow {
  display: flex;
  align-items: start;
  gap: 10px;
}
/* ---------- sizes ---------- */

.tsw-sm {
  width: 34px;
  height: 20px;
}
.tsw-sm .tsw-thumb {
  width: 16px;
  height: 16px;
}

.tsw-md {
  width: 52px;
  height: 26px;
}
.tsw-md .tsw-thumb {
  width: 22px;
  height: 22px;
}

.tsw-lg {
  width: 60px;
  height: 32px;
}
.tsw-lg .tsw-thumb {
  width: 28px;
  height: 28px;
}

/* ---------- variant: labeled (ON/OFF text inside track) ---------- */

.tsw-variant-labeled {
  min-width: 58px;
  width: auto;
  padding: 0 8px;
  justify-content: flex-end; /* off: thumb is on the left, text sits right */
}

.tsw-variant-labeled.tsw-on {
  justify-content: flex-start; /* on: thumb is on the right, text sits left */
}

.tsw-trackText {
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #fff;
  text-transform: uppercase;
  z-index: 1;
}

.tsw-variant-labeled:not(.tsw-on) .tsw-trackText {
  color: #6b7280;
}

.tsw-variant-labeled .tsw-thumb {
  position: absolute;
}

/* ---------- hover ---------- */

.tsw-track:not(.tsw-disabled):not(.tsw-on):hover {
  background: var(--cui-border-hover);
}

.tsw-track.tsw-on:not(.tsw-disabled):hover {
  filter: brightness(1.05);
}
/* ---------- error: red ring around the track ---------- */

.tsw-track.tsw-error {
  box-shadow: 0 0 0 2px var(--cui-danger);
}

.tsw-track.tsw-error:focus-visible {
  box-shadow: 0 0 0 2px var(--cui-danger), 0 0 0 5px var(--cui-danger-ring);
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomToggleSwitch/CustomToggleSwitch.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,yCAAyC;;AAEzC;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;AACA,gCAAgC;;AAEhC;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sEAAsE;;AAEtE;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,yBAAyB,EAAE,+CAA+C;AAC5E;;AAEA;EACE,2BAA2B,EAAE,8CAA8C;AAC7E;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gCAAgC;;AAEhC;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;AACA,2DAA2D;;AAE3D;EACE,uCAAuC;AACzC;;AAEA;EACE,yEAAyE;AAC3E","sourcesContent":[".tsw-group {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  width: 100%;\n  margin-bottom: var(--cui-field-margin);\n}\n\n.tsw-textCol {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.tsw-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--cui-text-label);\n}\n\n.tsw-required {\n  color: var(--cui-danger);\n  margin-left: 3px;\n}\n\n.tsw-desc {\n  font-size: 11.5px;\n  color: var(--cui-text-muted);\n  line-height: 1.4;\n}\n\n/* ---------- track (shared) ---------- */\n\n.tsw-track {\n  position: relative;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  border: none;\n  border-radius: 999px;\n  background: var(--cui-border);\n  cursor: pointer;\n  padding: 0;\n  transition: background 0.2s ease, box-shadow 0.15s ease;\n}\n\n.tsw-track:focus-visible {\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n.tsw-track.tsw-on {\n  background: linear-gradient(135deg, var(--cui-primary), var(--cui-primary-light));\n}\n\n.tsw-track.tsw-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.tsw-thumb {\n  position: absolute;\n  left: 2px;\n  top: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  transform: translateY(-50%);\n  transition: left 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.tsw-track.tsw-on .tsw-thumb {\n  left: calc(100% - 2px);\n  transform: translate(-100%, -50%);\n}\n\n.tsw-thumbIcon {\n  width: 60%;\n  height: 60%;\n  fill: none;\n  stroke: var(--cui-primary);\n  stroke-width: 3;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.tsw-track.tsw-on .tsw-thumbIcon {\n  stroke: var(--cui-primary);\n}\n\n.tsw-track:not(.tsw-on) .tsw-thumbIcon {\n  stroke: #a8adb8;\n}\n\n\n.tsw-controlRow {\n  display: flex;\n  align-items: start;\n  gap: 10px;\n}\n/* ---------- sizes ---------- */\n\n.tsw-sm {\n  width: 34px;\n  height: 20px;\n}\n.tsw-sm .tsw-thumb {\n  width: 16px;\n  height: 16px;\n}\n\n.tsw-md {\n  width: 52px;\n  height: 26px;\n}\n.tsw-md .tsw-thumb {\n  width: 22px;\n  height: 22px;\n}\n\n.tsw-lg {\n  width: 60px;\n  height: 32px;\n}\n.tsw-lg .tsw-thumb {\n  width: 28px;\n  height: 28px;\n}\n\n/* ---------- variant: labeled (ON/OFF text inside track) ---------- */\n\n.tsw-variant-labeled {\n  min-width: 58px;\n  width: auto;\n  padding: 0 8px;\n  justify-content: flex-end; /* off: thumb is on the left, text sits right */\n}\n\n.tsw-variant-labeled.tsw-on {\n  justify-content: flex-start; /* on: thumb is on the right, text sits left */\n}\n\n.tsw-trackText {\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  color: #fff;\n  text-transform: uppercase;\n  z-index: 1;\n}\n\n.tsw-variant-labeled:not(.tsw-on) .tsw-trackText {\n  color: #6b7280;\n}\n\n.tsw-variant-labeled .tsw-thumb {\n  position: absolute;\n}\n\n/* ---------- hover ---------- */\n\n.tsw-track:not(.tsw-disabled):not(.tsw-on):hover {\n  background: var(--cui-border-hover);\n}\n\n.tsw-track.tsw-on:not(.tsw-disabled):hover {\n  filter: brightness(1.05);\n}\n/* ---------- error: red ring around the track ---------- */\n\n.tsw-track.tsw-error {\n  box-shadow: 0 0 0 2px var(--cui-danger);\n}\n\n.tsw-track.tsw-error:focus-visible {\n  box-shadow: 0 0 0 2px var(--cui-danger), 0 0 0 5px var(--cui-danger-ring);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
